import '@vaadin/notification';
import { getComponentName } from '../../helpers/componentHelpers';

const vaadinContainerClass = window.customElements.get('vaadin-notification-container');

if (!vaadinContainerClass) {
  throw new Error('could not get vaadin-notification-container class');
}

class NotificationContainerClass extends vaadinContainerClass {}
customElements.define(getComponentName('notification-container'), NotificationContainerClass);

export { NotificationContainerClass };
